import { Holiday } from "./Holiday";

export class ListData {
    pageIndex: number;
    pageSize: number;
    totalCount: number;
    pageDate: Holiday[] = new Array();
}
